import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 3H3.414l1.293-1.293A.999.999 0 1 0 3.293.293l-3 3a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L3.414 5H11.5c3.584 0 6.5 2.916 6.5 6.5S15.084 18 11.5 18A6.508 6.508 0 0 1 5 11.5V11a1 1 0 0 0-2 0v.5c0 4.687 3.813 8.5 8.5 8.5 4.687 0 8.5-3.813 8.5-8.5C20 6.813 16.187 3 11.5 3"
});

var SvgUndoMajorMonotone = function SvgUndoMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgUndoMajorMonotone as S };